module.exports = __webpack_public_path__ + "assets/images/scene-1_8a2d144e8318185879a38157305123aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-one/croma-abeldo-dialogs/scene-1.png
// module id = 200
// module chunks = 0